const config = {
    env: 'production',
    // apiUrl: "https://api.bizcontrol.in/admin/admin/"

    apiUrl: "https://api.bizcontrol.in/admin/"
}

export default config;
